export const defaultChatContainerId = "default-chat-container";
